import { useNavigate } from 'react-router-dom'
import styles from './Showcase.module.css'

export function Showcase() {
  const navigate = useNavigate()
  const gameImages = [
    '/fc0_game_img_1.png',
    '/fc0_game_img_2.png',
    '/fc0_game_img_3.png',
    '/fc0_game_img_4.png',
  ]

  return (
    <section id='showcase' className={styles.section}>
      <div className={styles.inner}>
        <h2 className={styles.heading}>
          Discover games made with Fantasy Console 0
        </h2>
        <div className={styles.grid}>
          {gameImages.map((imageSrc, index) => (
            <div key={imageSrc} className={styles.card}>
              <img
                className={styles.cardImage}
                src={imageSrc}
                alt={`Featured game screenshot ${index + 1}`}
              />
            </div>
          ))}
        </div>
        <div className={styles.cta}>
          <button
            className='btn btn-secondary'
            onClick={() => navigate('/', { state: { view: 'library' } })}
          >
            View All Carts
          </button>
        </div>
      </div>
    </section>
  )
}
